const theme = {
  light: {
    primary: '#0096c7',
    secondary: '#a0b9c8',
    'light-primary': '#E3F2FD',
    'light-secondary': '#f4ffff',
    erorr: '#ff0303',
    info: '#0cac9d',
    success: "#1ed66d"
  },
  dark: {
    primary: '#0096c7',
    secondary: '#a0b9c8',
    'light-primary': '#E3F2FD',
    'light-secondary': '#f4ffff',
    erorr: '#ff0303',
    info: '#0cac9d',
    success: "#1ed66d"
  }
}

export default theme

